import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    exportToFrameio: string;
    cancel: string;
    export: string;
    close: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label for exporting the sequence to Frame.io */
            exportToFrameio: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportDialogContainer.exportToFrameio?c=3g9fl7wwp0sg5", defaultMessage: "Export to Frame.io" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to cancel the export process */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportDialogContainer.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to start the export process */
            export: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportDialogContainer.export?c=nl0l78hxbb9v", defaultMessage: "Export" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the button to close the export modal */
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportDialogContainer.close?c=2lqdljfvb0zna", defaultMessage: "Close export modal" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
